import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col, Table, Avatar } from 'antd';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';

import { pageChanged } from '../../../../../data/redux/page_details/actions';
import { updateMemberState, getAllAgents, getAllGroups, deleteGroup } from '../../../../../data/redux/member_details/actions';

import { APP_PAGES, APP_LAYOUT, ROUTE_PATH } from '../../../../../data/config/constants';
import { uniqueId, getAvatarBgClass, showMessage } from '../../../../../data/config/utils';
import { IMG_ERROR, IMG_EMPTY } from '../../../../../data/assets/img';

import PageHeaderLoader from '../../../../../components/pageheader/loaders';
import CardRowTableLoader from '../../../components/loaders/cardrowtable';
import AvatarCardLoader from '../../../../../components/avatarcard/loader';
import CustomHeader from '../../../../../components/customheader';
import ProfileAvatar from '../../../../../components/profileavatar';
import TableCellAction from '../../../components/tablecellaction';
import ShowMessage from '../../../../../components/showmessage';
import GroupDetailCard from './components/groupdetailcard';

class Groups extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      filtered_groups: props.member_details.groups,
      search_text: "",
    };
    this.columns = this.getGroupsTableColumns();
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.pageChanged(APP_PAGES.GROUPS, APP_PAGES.MEMBERS);
    actions.getAllAgents();
    actions.getAllGroups();
  }

  componentWillReceiveProps(nextProps) {
    const { member_details } = this.props;
    const { search_text } = this.state;
    if (!isEqual(nextProps.member_details.groups, member_details.groups)) {
      const groups = [...nextProps.member_details.groups];
      if (search_text.trim().length !== 0) {
        this.setState({
          filtered_groups: this.filterBySearchText(search_text, groups)
        });
      } else {
        this.setState({
          filtered_groups: groups
        });
      }
    }
  }

  getGroupsTableColumns = () => {
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        className: 'ori-l-pad-10',
        render: (text, group) => {
          return (
            <ProfileAvatar shape="square" container_class="ori-flex-ac" title={group.name} title_class="ori-font-sm ori-font-bold" />
          );
        }
      },
      {
        title: 'Members',
        dataIndex: 'members',
        key: 'members',
        render: (text, group) => {
          if (group.agents && group.agents.length > 0) {
            return (
              <span className="ori-l-pad-5">
                {
                  group.agents.map((member, index) => {
                    if (index < 5) {
                      const name = `${member.firstName} ${member.lastName}`;
                      return (
                        <Avatar key={index} style={{ lineHeight: '28px' }} className={classNames("ori-uppercase ori-align-avatar-letter ori-border-white-2 ori-l-mrgn-neg-5", { ...getAvatarBgClass(name) })}>{name ? name.charAt(0) : 'u'}</Avatar>
                      );
                    }
                    return null;
                  })
                }
                {
                  group.agents.length > 5 &&
                  <span className="ori-lr-pad-10 ori-font-11 ori-bg-default ori-lr-mrgn-5 ori-border-radius-20 ori-border-light ori-tb-pad-3">{`+${group.agents.length - 5} more`}</span>
                }
              </span>
            )
          }
          return null;
        }
      },
      {
        title: 'Created',
        dataIndex: 'createdBy',
        key: 'createdBy',
      },
      {
        title: 'Last updated',
        dataIndex: 'lastUpdatedBy',
        key: 'lastUpdatedBy',
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions',
        align: 'center',
        render: (text, record) => {
          return (
            <TableCellAction align_center show_user show_edit show_delete delete_popconfirm_title="Are you sure delete this group?" handleUserClick={this.props.actions.updateMemberState.bind(this, record, 'active_group')} handleEditClick={this.editGroup.bind(this, record)} handleDeleteClick={this.deleteGroup.bind(this, record)} />
          );
        }
      },
    ];
    return columns;
  };

  filterBySearchText = (text, array) => {
    return array.filter(item => {
      return (item.name && item.name !== undefined && item.name.toLowerCase().indexOf(text.toLowerCase()) !== -1);
    });
  };

  handleGroupsSearch = event => {
    const search_text = event.target.value;
    const { member_details } = this.props;
    this.setState({ search_text });
    if (search_text.trim().length !== 0) {
      this.setState({
        filtered_groups: this.filterBySearchText(search_text, member_details.groups)
      });
    } else {
      this.setState({
        filtered_groups: member_details.groups
      });
    }
  };

  addGroup = () => {
    const { history } = this.props;
    history.push(ROUTE_PATH.ADD_GROUP);
  };

  editGroup = group => {
    const { history } = this.props;
    if (group && group.name) {
      history.push(`${ROUTE_PATH.EDIT_GROUP}?name=${group.name}`);
    } else {
      showMessage('error', 'require data is missing in this group');
    }
  };

  deleteGroup = group => {
    if (group && group._id) {
      const payload = { _id: group._id };
      this.props.actions.deleteGroup(payload);
    } else {
      showMessage('error', '_id is missing in this group');
    }
  };

  onTableRow = record => {
    const { member_details } = this.props;
    return {
      className: member_details.active_group.name === record.name ? "ori-bg-default ori-l-border-primary-4" : "ori-bg-white ori-l-border-transparent-4",
    };
  };

  renderGroupsTable = () => {
    const { screen_width } = this.props;
    const { filtered_groups } = this.state;
    if (filtered_groups.length > 0) {
      return (
        <Table className="ori-table-default ori-table-header-bg-transparent" scroll={{ x: 450 }} size={screen_width < 768 ? "small" : "middle"} pagination={{ pageSize: 20 }} rowKey={uniqueId} onRow={this.onTableRow} columns={this.columns} dataSource={filtered_groups} />
      );
    }
    return (
      <ShowMessage img_src={IMG_EMPTY} height={150} width={150} title="Empty group list" message="There is no any group. please click on add new group button to add group" />
    );
  };

  renderGroupDetailsCard = () => {
    const { member_details } = this.props;
    if (!isEmpty(member_details.active_group)) {
      return (
        <GroupDetailCard group={member_details.active_group} onClickEdit={this.editGroup} />
      );
    }
  };

  render() {
    const { screen_height, member_details } = this.props;

    if (member_details.loaders.groups_loading && !member_details.loaders.groups_loaded) {
      return (
        <div className="ori-lr-pad-10">
          <Row gutter={20}>
            <Col xs={24} sm={16} md={18}>
              <PageHeaderLoader bottom_bordered />
              <div className="ori-tb-pad-10">
                <CardRowTableLoader />
              </div>
            </Col>
            <Col xs={24} sm={8} md={6} className="ori-t-pad-20 ori-b-pad-15 ori-l-pad-5 ori-overflow-x-hidden ori-overflow-y-auto" style={{ height: `${screen_height - APP_LAYOUT.APP_HEADER_HEIGHT - APP_LAYOUT.PAGE_NAVBAR_HEIGHT}px` }}>
              <AvatarCardLoader />
            </Col>
          </Row>
        </div>
      )
    } else if (!member_details.loaders.groups_loading && member_details.loaders.groups_loaded) {
      return (
        <div className="ori-lr-pad-10">
          <Row gutter={20}>
            <Col xs={24} sm={16} md={18}>
              <CustomHeader title="Groups" first_button_type="primary" search_placeholder="search groups" onChangeSearch={this.handleGroupsSearch} first_button_text="+ Add new group" onClickFirstButton={this.addGroup} bottom_bordered show_search show_first_button />
              {this.renderGroupsTable()}
            </Col>
            <Col xs={24} sm={8} md={6} className="ori-b-pad-10 ori-l-pad-5 ori-overflow-x-hidden ori-overflow-y-auto" style={{ height: `${screen_height - APP_LAYOUT.APP_HEADER_HEIGHT - APP_LAYOUT.PAGE_NAVBAR_HEIGHT}px` }}>
              {this.renderGroupDetailsCard()}
            </Col>
          </Row>
        </div>
      );
    } else if (!member_details.loaders.groups_loading && !member_details.loaders.groups_loaded) {
      return (
        <ShowMessage img_src={IMG_ERROR} title="Error" message="unable to load group list. please check your internet connection and reload the page." height={150} width={150} />
      )
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => {
  return {
    screen_width: state.page_details.device_data.screen_width,
    screen_height: state.page_details.device_data.screen_height,
    member_details: state.member_details,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      pageChanged,
      updateMemberState,
      getAllAgents,
      getAllGroups,
      deleteGroup
    }, dispatch),
  };
};

Groups.propTypes = {
  member_details: PropTypes.object,
  screen_height: PropTypes.number,
  screen_width: PropTypes.number,
  actions: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Groups);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/members/groups/index.js